// Reusable inline video player (snippets/mm-video). Poster + gold play button;
// click to play and hand over to the browser's NATIVE controls (volume, scrub,
// fullscreen). Once started, the play button stays hidden until the clip ends.
(function () {
  function start(wrap) {
    var v = wrap.querySelector('.mm-video__el');
    if (!v) return;
    // Pause any other players first.
    document.querySelectorAll('.mm-video.is-started .mm-video__el').forEach(function (other) {
      if (other !== v) other.pause();
    });
    v.setAttribute('controls', 'controls');
    var pr = v.play();
    if (pr && pr.catch) pr.catch(function () {});
    wrap.classList.add('is-playing', 'is-started');
  }

  document.addEventListener('click', function (e) {
    var wrap = e.target.closest('[data-mm-video]');
    if (!wrap) return;
    // Once started, the native controls own the clicks (play/pause/volume).
    if (wrap.classList.contains('is-started')) return;
    e.preventDefault();
    start(wrap);
  });

  // When the clip ends, reset to the poster + play button (the "not played yet" state).
  document.addEventListener('ended', function (e) {
    var v = e.target;
    if (v.classList && v.classList.contains('mm-video__el')) {
      var wrap = v.closest('.mm-video');
      if (wrap) wrap.classList.remove('is-playing', 'is-started');
      v.removeAttribute('controls');
      v.load(); // restores the poster frame
    }
  }, true);
})();
